import { render } from "./PhoneVerification.html?vue&type=template&id=2b670709&scoped=true&ts=true&external"
import script from "./PhoneVerification.vue?vue&type=script&lang=ts"
export * from "./PhoneVerification.vue?vue&type=script&lang=ts"

import "./PhoneVerification.scss?vue&type=style&index=0&id=2b670709&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b670709"]])

export default __exports__